import React from 'react'
import { Redirect } from "react-router-dom"

class Redirects {
    events: {
        [key: string]: string | null
    }

    constructor() {
        const events = localStorage.getItem('events')
        if (!events) localStorage.setItem("events", "{}")
        this.events = JSON.parse(events || "{}")
    }

    refreshStorage() {
        localStorage.setItem("events", JSON.stringify(this.events))
    }

    on(event: string, url: string): void {
        this.events[event] = url
        this.refreshStorage()
    }

    exists(event: string): boolean {
        return Boolean(this.events[event])
    }

    apply(event: string): JSX.Element | null {
        if (!this.exists(event)) return null
        const url = this.events[event] as string
        this.remove(event)
        return <Redirect to={url} />
    }

    remove(event: string): void {
        this.events[event] = null
        this.refreshStorage()
    }

    clear(): void {
        this.events = {}
        this.refreshStorage()
    }
}

export default new Redirects()